export class ChatClientError extends Error {
  constructor(message: string, options?: { cause?: unknown }) {
    super(message, options);
    this.name = 'ChatClientError';
  }
}

export class ChatHttpError extends ChatClientError {
  readonly status: number;
  // The machine-readable reason the server gave, when it gave one. A status
  // says a request was refused; only this says why — and "why" is the
  // difference between a session that can be renewed and a refusal that
  // must stand.
  readonly code: string | null;

  constructor(status: number, message: string, code: string | null = null) {
    super(message);
    this.name = 'ChatHttpError';
    this.status = status;
    this.code = code;
  }
}

export class ChatWebSocketError extends ChatClientError {
  constructor(message: string, options?: { cause?: unknown }) {
    super(message, options);
    this.name = 'ChatWebSocketError';
  }
}
